var _style, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconActionBarTrash = function SvgIconActionBarTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16.5 17.5",
    style: {
      enableBackground: "new 0 0 16.5 17.5"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C4566;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.1,14.1c0.4,0,0.7-0.3,0.7-0.7V7c0-0.4-0.3-0.7-0.7-0.7S5.5,6.6,5.5,7v6.4C5.5,13.8,5.8,14.1,6.1,14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.8,2.7h-4.1V2c0-1.1-0.9-2-1.9-2H6.7C5.6,0,4.8,0.9,4.8,2v0.7H0.7C0.3,2.7,0,3,0,3.4S0.3,4,0.7,4H2 l0.3,10.3c0.1,1.8,1.4,3.1,3.1,3.1h5.6c1.7,0,3.1-1.4,3.1-3.1L14.5,4h1.3c0.4,0,0.7-0.3,0.7-0.7S16.2,2.7,15.8,2.7z M10.4,2v0.7 H6.1V2c0-0.3,0.3-0.6,0.6-0.6h3.1C10.2,1.4,10.4,1.6,10.4,2z M12.9,14.3c0,1-0.8,1.8-1.8,1.8H5.5c-1,0-1.8-0.8-1.8-1.8L3.3,4h9.9 L12.9,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.4,14.1c0.4,0,0.7-0.3,0.7-0.7V7c0-0.4-0.3-0.7-0.7-0.7S7.7,6.6,7.7,7v6.4C7.7,13.8,8,14.1,8.4,14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.6,14.1c0.4,0,0.7-0.3,0.7-0.7V7c0-0.4-0.3-0.7-0.7-0.7S10,6.6,10,7v6.4C10,13.8,10.2,14.1,10.6,14.1z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconActionBarTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-action-bar-trash.b1589206.svg";
export { ForwardRef as ReactComponent };